/**
 * Paging a product's shots from inside the grid.
 *
 * Resting state is shot 1. Hovering reveals shot 2, which is the behaviour the
 * cards already had and which reads as "here it is on a hand". The arrows take
 * over from there: once one is pressed the card holds that shot until the
 * pointer leaves, so hover cannot yank the image back while you are looking at
 * it.
 *
 * Everything is opacity on stacked images, so paging costs no layout and no
 * network beyond the images the card already lazy-loads.
 */
(function () {
  "use strict";

  var pointer = window.matchMedia("(hover: hover) and (min-width: 1000px)");

  function init(frame) {
    if (frame.__calmyCardNav) return;
    frame.__calmyCardNav = true;

    var imgs = [].slice.call(frame.querySelectorAll(".ccard__img"));
    var dots = [].slice.call(frame.querySelectorAll(".ccard__dot"));
    if (imgs.length < 2) return;

    var index = 0;
    var held = false; // an arrow was used; hover must not override

    function show(i) {
      index = (i + imgs.length) % imgs.length;
      imgs.forEach(function (im, j) { im.classList.toggle("is-on", j === index); });
      dots.forEach(function (d, j) { d.classList.toggle("is-on", j === index); });
    }

    frame.addEventListener("mouseenter", function () {
      if (!pointer.matches || held) return;
      show(1);
    });

    frame.addEventListener("mouseleave", function () {
      held = false;
      show(0);
    });

    frame.querySelectorAll("[data-calmy-card-go]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        // The frame contains a link to the product; paging is not navigating.
        e.preventDefault();
        e.stopPropagation();
        held = true;
        show(index + parseInt(btn.getAttribute("data-calmy-card-go"), 10));
      });
    });
  }

  function boot(root) {
    (root || document).querySelectorAll("[data-calmy-card]").forEach(init);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { boot(); });
  else boot();

  // Grids that paginate, filter or load more replace their cards wholesale.
  if ("MutationObserver" in window) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) boot(n); });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
